module.exports = __webpack_public_path__ + "img/caminito-rey-2.409259d7.jpg";